import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { Observable, throwError } from 'rxjs';
import { catchError, publishReplay, refCount, retry, take } from 'rxjs/operators';

export interface ProductsByCategoryPayload {
  baseProductId: any;
  fields: string;
  restrictedProductCode: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomProductService {
  headers = new HttpHeaders().set('Content-Type', 'application/json');
  cacheWindowTime = 120000; // 2 minutes
  private cachedProductsByCategory$: any = {};

  constructor(protected http: HttpClient, private occEndpointsService: OccEndpointsService) {}

  getProductsByCategory(payload: ProductsByCategoryPayload): Observable<any> {
    const idString = [payload.baseProductId, payload.restrictedProductCode].join();
    const params = new HttpParams()
      .set('fields', payload.fields)
      .set('restrictedProductCode', payload.restrictedProductCode);

    if (!this.cachedProductsByCategory$[idString]) {
      this.cachedProductsByCategory$[idString] = this.http
        .get(this.occEndpointsService.buildUrl(`/categories/${payload.baseProductId}/productsByCategory`), {
          params,
          headers: this.headers,
        })
        .pipe(publishReplay(1, this.cacheWindowTime), refCount(), take(1), catchError(this.errorHandl));
    }
    return this.cachedProductsByCategory$[idString];
  }
  getProductInfo(productCode: any): Observable<any> {
    return this.http
      .get(this.occEndpointsService.buildUrl(`/products/productInfo/${productCode}`), {
        headers: this.headers,
      })
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getSkipVariant(): Observable<any> {
    return this.http
      .get(`../../../public/features/PRODUCT_PAGE_FEATURES.json`)
      .pipe(retry(1), catchError(this.errorHandl));
  }

  getExplodedViewDetails(explodedViewId: string): Observable<any> {
    return this.http
      .get(this.occEndpointsService.buildUrl(`/products/explodedView/${explodedViewId}`))
      .pipe(catchError((error: any) => throwError(error)));
  }

  // Error handling
  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(errorMessage);
  }
}
